import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import type { UpsertConductData } from "~pages/Conducts/types/upsertConductData.ts";
import UpsertConductModal from "./UpsertConductModal.tsx";

type Props = {
  onAdd: (upsertData: UpsertConductData) => void;
  isAddingInProcess: boolean;
};
const AddConductButton = ({ onAdd, isAddingInProcess }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <>
      <Button onClick={() => setOpenModal(true)} icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />} type={"primary"}>
        {formatMessage({ id: "conduct.add" })}
      </Button>
      {openModal && <UpsertConductModal onUpsert={onAdd} onClose={() => setOpenModal(false)} isUpsertInProcess={isAddingInProcess} />}
    </>
  );
};

export default AddConductButton;
